import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import show_partstudio_svg from '../../../assets/img/SVG_icons/Top/reference_operation/show_reference_model.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { hide_reference_partstudio_model, show_reference_partstudio_model } from '@frontend/scene';
import ShowPartstudioTooltip from './ShowPartstudioTooltip';

export const ShowPartstudioIcon = show_partstudio_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide PartStudio references';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                )
                || this.state.imported_partstudio_reference_models.length === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.showing_reference_partstudio_models)
                hide_reference_partstudio_model();
            else
                show_reference_partstudio_model();
        },
    },

    render() {
        return h(BarButton, {
            id: 'show-partstudio-model-button',
            onClick: this.onClick,
            disabled: this.disabled,
            active: this.state.showing_reference_partstudio_models,
            selected: this.state.tut_stage === 13,
            tippy: 'top',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_partstudio_svg, this.alt),
            tooltip: ShowPartstudioTooltip,
        });
    },
});
